<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar" v-show="!page.popShow">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Contact Management</span>
        </div>
      </div>
      <div class="table-wrap">
        <el-table :data="table.data" v-loading="table.isLoading" element-loading-text="LOADING" style="width: 100%">
          <el-table-column prop="CaName" label="Name"></el-table-column>
          <el-table-column prop="CaSort" label="Sort"></el-table-column>
          <el-table-column label="Operate">
            <template scope="scope">
              <el-button size="small" v-on:click="showUpdatePop(scope.$index, scope.row)">edit</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
     <div class="field-box scroll-cotar" v-show="page.popShow">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Address Detail</span>
        </div>
        <div class="rfp">
          <el-button size="small" type="danger" @click="page.popShow = false">Close</el-button>
        </div>
      </div>
      <ContactForm @updateSuccess="handleUpdate" ref="popForm"></ContactForm>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import ContactForm from '@/components/config/ContactForm'

// 请求相关操作
let page = {
  methods: {
    // 获取数据操作
    GetDataAjax() {
      tools.commonAjax.call(this, true, '/Ajax/GetCompanyAddressListInAdmin', {
        All: 1,
        OrderName: 'CA_SORT DESC'
      }).then((response) => {
        let result = response.data
        this.table.data = result
      })
    }
  }
}

export default {
  name: 'ContactManagement',
  mixins: [page],
  components: {
    ContactForm
  },
  created() {
    this.GetDataAjax()
  },
  data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    }
  },
  computed: {
  },
  methods: {
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.setValue(item)
      })
    },
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.GetDataAjax()
      this.page.popShow = false
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// ContactManage.vue?0ce04a28